import styles from "./home-icon.module.css";

interface HomeIconProps {
  variant: "small" | "large";
}

export const HomeIcon = ({ variant = "small" }: HomeIconProps) => {
  return <div className={`${styles["home-icon"]} ${styles[variant]}`}>H</div>;
};
